import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import svg from "../components/svg";
import { useStore } from "../zustand/store";
import Cookies from "js-cookie";
import { setMyState, getNameInitials, assetsUrlPath } from "../components/commonAction";
import HeaderResponsive from './common/responsiveHeader/ResponsiveHeader';
import appConfig from '../config/appConfig';
import {
    LayoutDashboard,
    CreditCard,
    Users,
    BriefcaseBusiness,
    Settings,
    Code2,
    LogOut,
} from 'lucide-react';

/* Consistent size for every nav icon */
const ICON_SIZE = 18;

function Sidebar() {
    const [path, setpath] = useState(useLocation().pathname.replace(/^\//, ''));
    let adminPath = useLocation().pathname.replace("admin/", "");
    const modalRef = useRef();
    const profileTriggerRef = useRef();
    const dropdownRef = useRef();
    let store = useStore(state => state);
    let { name, email, isVerified, role, socialAccountError, profilePic } = store.userData;
    const navigate = useNavigate();

    const [loginmenuToggle, SetloginmenuToggle] = useState(false);
    const [dropdownPos, setDropdownPos] = useState({});
    const [accountError, SetaccountError] = useState(false);
    const [tooltip, setTooltip] = useState({ visible: false, label: '', x: 0, y: 0 });

    const showTooltip = (e, label) => {
        if (store.resMenuToggle) return; // only in collapsed mode
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({ visible: true, label, x: rect.right + 10, y: rect.top + rect.height / 2 });
    };
    const hideTooltip = () => setTooltip(t => ({ ...t, visible: false }));

    let logoutMe = () => {
        store.updateStore("userData", {});
        Cookies.remove('authToken');
        navigate('/');
    }

    const [state, setState] = useState({ isActiveMenu: '' });

    const location = useLocation();
    useEffect(() => {
        if (window.innerWidth <= 767 && store.resMenuToggle) {
            store.updateStore("resMenuToggle", false);
        }
    }, [location.pathname]);

    const openDropdown = () => {
        if (loginmenuToggle) {
            SetloginmenuToggle(false);
            return;
        }
        if (!profileTriggerRef.current) return;
        const rect = profileTriggerRef.current.getBoundingClientRect();
        const isCollapsed = !store.resMenuToggle;

        if (isCollapsed) {
            setDropdownPos({
                position: 'fixed',
                left: rect.right + 10,
                bottom: window.innerHeight - rect.bottom,
                zIndex: 10000,
            });
        } else {
            setDropdownPos({
                position: 'fixed',
                left: rect.left,
                bottom: window.innerHeight - rect.top + 8,
                width: rect.width,
                zIndex: 10000,
            });
        }
        SetloginmenuToggle(true);
    };

    useEffect(() => {
        if (!loginmenuToggle) return;
        const handleClick = (e) => {
            const clickedTrigger = profileTriggerRef.current?.contains(e.target);
            const clickedDropdown = dropdownRef.current?.contains(e.target);
            if (!clickedTrigger && !clickedDropdown) {
                SetloginmenuToggle(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [loginmenuToggle]);

    const dropdown = loginmenuToggle ? ReactDOM.createPortal(
        <div ref={dropdownRef} className="pxl-profile-dropdown-portal" style={dropdownPos}>
            <ul className="pxl-account-logout-wrap">
                <li>
                    <Link
                        to={role === 'admin' ? "/admin/account-settings#profile" : "/account-settings#profile"}
                        className="pxl_navlink"
                        onClick={() => SetloginmenuToggle(false)}
                    >
                        <span className="pxl_menuIcon"><Settings size={ICON_SIZE} strokeWidth={1.8} /></span>
                        <span className="pxl_textMenu">Account Settings</span>
                    </Link>
                </li>
                <li className="pxl-logout-item">
                    <a className="pxl_navlink" onClick={() => { SetloginmenuToggle(false); logoutMe(); }}>
                        <span className="pxl_menuIcon"><LogOut size={ICON_SIZE} strokeWidth={1.8} /></span>
                        <span className="pxl_textMenu">Logout</span>
                    </a>
                </li>
            </ul>
        </div>,
        document.body
    ) : null;

    return (
        <>
            {/* ── Mobile top bar ── */}
            <header className="pxl-mobile-header">
                <Link to={role === 'admin' ? '/admin/dashboard' : '/dashboard'} className="pxl-mobile-header-logo">
                    <img src={appConfig.appLogo} alt="PixaLab" />
                </Link>
                <button
                    className={`pxl-mobile-menu-btn ${store.resMenuToggle ? 'is-open' : ''}`}
                    onClick={() => store.updateStore("resMenuToggle", !store.resMenuToggle)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </header>

            <div className="">
                <div className='cun-responsive-toggle'>
                    <div className='sch-responsive-toggle'>
                    </div>
                </div>
                <div className={`pxl_sidebarMenu ${store.resMenuToggle ? 'opensidebar' : 'closesidebar'}`} ref={modalRef} style={{backgroundImage: `url(/assets/images/sidebar_bg.png)`}}>

                    <div className="sidebarCloseWrap" onClick={() => store.updateStore("resMenuToggle", !store.resMenuToggle)}>
                        <div className="sidebarClose">
                            <span className="sidebarCloseBg">
                            <svg width="20" height="90" viewBox="0 0 12 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0.48999C0 3.54437 1.7357 6.39588 4.54212 7.62439C8.50944 9.37137 11.2708 13.3387 11.2708 17.9484V63.0316C11.2708 67.6413 8.49817 71.6086 4.54212 73.3556C1.74697 74.5841 0 77.4356 0 80.49V0.48999Z"></path>
                            </svg>
                            </span>
                            <span className="sidebarCloseIcon">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 8.09566C6 9.39411 4.41617 10.0219 3.53151 9.06593L0.321046 5.6129C-0.107015 5.14203 -0.107015 4.38579 0.321046 3.91492L3.53151 0.461886C4.41617 -0.494119 6 0.133705 6 1.43216V8.09566Z"></path>
                            </svg>
                            </span>
                        </div>
                    </div>

                    <div className="pxl_sidebar_logo_wrap">
                        <Link to={role === 'admin' ? '/admin/dashboard' : '/dashboard'} className="pxl_sidebar_logo">
                            <img className="pxl_sidebar_main_logo" src={appConfig.appLogo} alt="Logo" />
                            <img className="pxl_sidebar_mini_logo" src={appConfig.miniAppLogo} alt="mini-logo" />
                        </Link>
                    </div>

                    <div className="pxl_mainMenu">
                        {
                            role === 'admin' ? (
                                <ul>
                                    <li className={(adminPath === '/dashboard') ? 'isActive' : ''} data-tooltip="Dashboard" onMouseEnter={e => showTooltip(e, 'Dashboard')} onMouseLeave={hideTooltip}>
                                        <Link to={'/admin/dashboard'} className={`pxl_navlink`}>
                                            {adminPath === '/dashboard' && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                            <span className="pxl_menuIcon"><LayoutDashboard size={ICON_SIZE} strokeWidth={1.8} /></span>
                                            <span className='pxl_textMenu'>Dashboard</span>
                                        </Link>
                                    </li>
                                    <li className={(adminPath === '/users') ? 'isActive' : ''} data-tooltip="Users" onMouseEnter={e => showTooltip(e, 'Users')} onMouseLeave={hideTooltip}>
                                        <Link to={'/admin/users'} className={`pxl_navlink`}>
                                            {adminPath === '/users' && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                            <span className="pxl_menuIcon"><Users size={ICON_SIZE} strokeWidth={1.8} /></span>
                                            <span className='pxl_textMenu'>Users</span>
                                        </Link>
                                    </li>
                                    <li className={(adminPath === '/api-documentations') ? 'isActive' : ''} data-tooltip="API" onMouseEnter={e => showTooltip(e, 'API')} onMouseLeave={hideTooltip}>
                                        <Link to={'/admin/api-documentations'} className={`pxl_navlink`}>
                                            {adminPath === '/api-documentations' && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                            <span className="pxl_menuIcon"><Code2 size={ICON_SIZE} strokeWidth={1.8} /></span>
                                            <span className='pxl_textMenu'>API</span>
                                        </Link>
                                    </li>
                                    <li className={adminPath.startsWith('/billing') ? 'isActive' : ''} data-tooltip="Billing" onMouseEnter={e => showTooltip(e, 'Billing')} onMouseLeave={hideTooltip}>
                                        <Link to={'/admin/billing/tiers'} className={`pxl_navlink`}>
                                            {adminPath.startsWith('/billing') && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                            <span className="pxl_menuIcon"><CreditCard size={ICON_SIZE} strokeWidth={1.8} /></span>
                                            <span className='pxl_textMenu'>Billing</span>
                                        </Link>
                                    </li>
                                    <li className={adminPath.startsWith('/affiliates') ? 'isActive' : ''} data-tooltip="Affiliates" onMouseEnter={e => showTooltip(e, 'Affiliates')} onMouseLeave={hideTooltip}>
                                        <Link to={'/admin/affiliates'} className={`pxl_navlink`}>
                                            {adminPath.startsWith('/affiliates') && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                            <span className="pxl_menuIcon"><BriefcaseBusiness size={ICON_SIZE} strokeWidth={1.8} /></span>
                                            <span className='pxl_textMenu'>Affiliates</span>
                                        </Link>
                                    </li>
                                </ul>
                            ) : (
                                <ul>
                                    <li className={path === 'dashboard' ? 'isActive' : ''} data-tooltip="Dashboard" onMouseEnter={e => showTooltip(e, 'Dashboard')} onMouseLeave={hideTooltip}>
                                        <Link to={'/dashboard'} className={`pxl_navlink`}>
                                            {path === 'dashboard' && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                            <span className="pxl_menuIcon"><LayoutDashboard size={ICON_SIZE} strokeWidth={1.8} /></span>
                                            <span className='pxl_textMenu'>Dashboard</span>
                                        </Link>
                                    </li>
                                    {store.billing?.hasActivity && (
                                        <li className={path.startsWith('account/') ? 'isActive' : ''} data-tooltip="My Billing" onMouseEnter={e => showTooltip(e, 'My Billing')} onMouseLeave={hideTooltip}>
                                            <Link to={'/account/entitlements'} className={`pxl_navlink`}>
                                                {path.startsWith('account/') && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                                <span className="pxl_menuIcon"><CreditCard size={ICON_SIZE} strokeWidth={1.8} /></span>
                                                <span className='pxl_textMenu'>My Billing</span>
                                            </Link>
                                        </li>
                                    )}
                                    {role === 'affiliate' && (
                                        <li className={path.startsWith('affiliate') ? 'isActive' : ''} data-tooltip="Affiliate" onMouseEnter={e => showTooltip(e, 'Affiliate')} onMouseLeave={hideTooltip}>
                                            <Link to={'/affiliate/dashboard'} className={`pxl_navlink`}>
                                                {path.startsWith('affiliate') && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                                <span className="pxl_menuIcon"><BriefcaseBusiness size={ICON_SIZE} strokeWidth={1.8} /></span>
                                                <span className='pxl_textMenu'>Affiliate</span>
                                            </Link>
                                        </li>
                                    )}
                                    <li className={path === 'account-settings' ? 'isActive' : ''} data-tooltip="Settings" onMouseEnter={e => showTooltip(e, 'Settings')} onMouseLeave={hideTooltip}>
                                        <Link to={'/account-settings'} className={`pxl_navlink`}>
                                            {path === 'account-settings' && <span className="pxl_menuActiveIcon">{svg.app.menuActiveIcon}</span>}
                                            <span className="pxl_menuIcon"><Settings size={ICON_SIZE} strokeWidth={1.8} /></span>
                                            <span className='pxl_textMenu'>Settings</span>
                                        </Link>
                                    </li>
                                </ul>
                            )
                        }

                        <div
                            ref={profileTriggerRef}
                            className={`pxl_profileDetail pxl-logutSection-wrap ${loginmenuToggle ? "loginMenuOpen" : "loginMenuClose"}`}
                            onClick={openDropdown}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className={`pxl_profileImg toggle_profile`}>
                                <span className='pxl_imgHolder toggle_profile'>
                                    {
                                        profilePic ?
                                            <img src={assetsUrlPath(profilePic)} className='img-responsive img-circle toggle_profile' alt='Profile Image' />
                                            :
                                            getNameInitials(name)
                                    }
                                </span>
                                <div className='pxl_profileName toggle_profile'>
                                    <h4 className='toggle_profile'>{name}</h4>
                                    <p className='toggle_profile'>{email}</p>
                                    {!isVerified && (
                                        <span
                                            className='pxl-verify-pill'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate('/account-settings#verification');
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            Verify account
                                        </span>
                                    )}
                                </div>
                                <svg
                                    className={`pxl-profile-chevron${loginmenuToggle ? ' is-open' : ''}`}
                                    viewBox="0 0 24 24" width="16" height="16"
                                    fill="none" stroke="currentColor"
                                    strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
                                >
                                    <polyline points="6 9 12 15 18 9"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {dropdown}

            {tooltip.visible && ReactDOM.createPortal(
                <div className="pxl-nav-tooltip" style={{ top: tooltip.y, left: tooltip.x }}>
                    {tooltip.label}
                </div>,
                document.body
            )}
        </>
    )
}

export default Sidebar
